import React from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

import { ONBOARDING_STEPS } from '../../../../types';
import { OnboardingArrows } from '../../onboarding-arrows/onboarding-arrows';
import { ReportCard } from '../../../report-card/report-card';
import { useOnboardingContext } from '../../../../onboarding.context';
import { useReportBuilderContext } from '../../../../report-builder.context';
import { useTemplatesContext } from '../../../../templates.context';

import styles from './onboarding-templates-panel.scss';

interface OnboardingTemplatesPanelProps {
  onTemplateDragStart?: (e: React.DragEvent<HTMLDivElement | HTMLSpanElement>, templateId: string) => void;
}

export const OnboardingTemplatesPanel = ({ onTemplateDragStart }: OnboardingTemplatesPanelProps) => {
  const { currentStep, isNextEnabled } = useOnboardingContext();
  const { pageSetup } = useReportBuilderContext();
  const { onboardingTemplates } = useTemplatesContext();

  const dragEnabled = currentStep === ONBOARDING_STEPS.ADD_TEMPLATE && !isNextEnabled;

  const t = onboardingTemplates.find(t => t.orientation === pageSetup.orientation);

  return (
    <div className={styles.container}>
      <div className={clsx(styles.cardsContainer)}>
        {t && (
          <ReportCard
            key={t.id}
            isTemplate
            isDisabled={!dragEnabled}
            orientation={pageSetup.orientation}
            report={t}
            isDraggable={dragEnabled}
            onDragStart={dragEnabled ? e => onTemplateDragStart?.(e, t.id) : undefined}
          />
        )}
      </div>
      <p className={styles.text}>
        <FormattedMessage
          id="onboarding.over_60_templates_to_choose_from"
          defaultMessage="When you’ve finished onboarding you’ll have over 60 templates to choose from here!"
        />
      </p>
      <OnboardingArrows position="sidebar" />
    </div>
  );
};
